import React, { PureComponent } from 'react';
import { Button } from '../ui/button';

export interface Props {}

export interface State {
  error: boolean;
}

export default class ErrorBoundary extends PureComponent<Props, State> {
  state = {
    error: false
  };

  componentDidCatch(error: Error) {
    this.setState({ error: true });
  }

  reset = () => this.setState({ error: false });

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (!error) return children;

    return (
      <div className="h-full max-w-[300px] mx-auto text-center flex items-center justify-center">
        <div className="inline-block align-middle relative whitespace-normal">
          <div className="pb-5">
            We&apos;re sorry but something has gone wrong. Our team has been notified about it.
          </div>

          <Button onClick={this.reset} variant="secondary">
            Try again
          </Button>
        </div>
      </div>
    );
  }
}
